import { useState } from 'react';
import { Layout } from '../../components/Layout';
import Content from './Content';
import { ControlItem } from './types';

const items = {
  Health: [ControlItem.HealthCheck],
  Logs: [
    ControlItem.ServiceLogs,
    ControlItem.BotLogs,
    ControlItem.ErrorLogs,
    ControlItem.Queues,
  ],
  Users: [
    ControlItem.CreateUser,
    ControlItem.EditUser,
    ControlItem.ManagePassword,
    ControlItem.RemoveUser,
    ControlItem.PanicSell,
  ],
  Bots: [
    ControlItem.CreateBot,
    ControlItem.EditBot,
    ControlItem.RemoveBot,
    ControlItem.BotStates,
  ],
  Subscriptions: [
    ControlItem.CreateSubscription,
    ControlItem.EditSubscription,
    ControlItem.RemoveSubscription,
    ControlItem.SubscriptionStates,
  ],
  Balance: [
    ControlItem.AddBalance,
    ControlItem.MoveBalance,
    ControlItem.RemoveBalance,
  ],
};

const Control = () => {
  const [activeItem, setActiveItem] = useState(ControlItem.HealthCheck);

  return (
    <Layout>
      <Layout.SideMenu>
        {Object.entries(items).map(([title, items]) => (
          <Layout.SideMenuSection key={title}>
            <Layout.SideMenuTitle title={title} count={items.length} />
            <>
              {items.map((item) => (
                <Layout.SideMenuItem
                  key={item}
                  id={item}
                  label={item}
                  onClick={setActiveItem}
                  isActive={activeItem === item}
                />
              ))}
            </>
          </Layout.SideMenuSection>
        ))}
      </Layout.SideMenu>

      <Layout.Content>
        <Content activeItem={activeItem} setActiveItem={setActiveItem} />
      </Layout.Content>
    </Layout>
  );
};

export default Control;
